import Combobox, {LabelPosition, Size} from '@ls/react-combobox-grid';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {calcTypeOptions} from 'state/Constants/CalcType';
import {selectCovarianceOptions} from 'state/selections/selectors';
import {selectFactorOptions} from 'state/trackingError/selectors';
import {Cell, Grid} from 'styled-css-grid';

const TrackingErrorComplication = ({setDefinition, definition}) => {
  const factorOptions = useSelector(selectFactorOptions);
  const covarianceOptions = useSelector(selectCovarianceOptions);

  const [setFactor, setCovarianceType, setCalcType] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setFactor(value)),
      (value) => setDefinition(definition.setCovarianceType(value)),
      (value) => setDefinition(definition.setCalcType(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell width={1}>
        <Combobox
          label="Factor:"
          onChange={setFactor}
          options={factorOptions}
          labelPosition={LabelPosition.TOP}
          value={definition.factor}
          placeholder="Factors..."
          gridHeight={100}
          size={Size.S}
          variation={0}
        />
      </Cell>
      <Cell width={1}>
        <Combobox
          label="Covariance Type:"
          onChange={setCovarianceType}
          options={covarianceOptions}
          labelPosition={LabelPosition.TOP}
          value={definition.covarianceType}
          placeholder="Covariance..."
          gridHeight={100}
          size={Size.S}
          variation={0}
        />
      </Cell>
      {/*<Cell width={1}>*/}
      {/*  <Combobox*/}
      {/*    options={scaleTypeOptions}*/}
      {/*    onChange={setScaleType}*/}
      {/*    value={definition.scaleType}*/}
      {/*    label="Type:"*/}
      {/*    placeholder="Types..."*/}
      {/*    clearable={false}*/}
      {/*    variation={0}*/}
      {/*    size={'S'}*/}
      {/*    gridHeight={120}*/}
      {/*  />*/}
      {/*</Cell>*/}
      <Cell width={1}>
        <Combobox
          options={calcTypeOptions}
          onChange={setCalcType}
          value={definition.calcType}
          label="Calc:"
          clearable={false}
          variation={0}
          size={'S'}
          gridHeight={120}
        />
      </Cell>
    </Grid>
  );
};

TrackingErrorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(TrackingErrorComplication);
